import { FC } from 'react';
import { BoxV2 as Box, SxProps } from 'portal-commons';

const SectionGrid: FC<{ sx?: SxProps }> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        rowGap: '16px',
        columnGap: '20px',
        width: '100%',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default SectionGrid;
